import { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=not authenticated, object=authenticated

  useEffect(() => {
    apiClient
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    const res = await apiClient.post("/auth/login", { email, password });
    setAdmin(res.data);
    return res.data;
  };

  const logout = async () => {
    await apiClient.post("/auth/logout");
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
